import React from 'react';

import Radium from '@flipdish/radium';
import axios from 'axios';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
// eslint-disable-next-line import/named
import { Link, RouteComponentProps } from 'react-router';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import * as Actions from '../../actions/Actions';
import * as BasketControl from '../../BasketControl';
import { basketSelectors } from '../../redux';
import * as Routes from '../../Routes';
import { menuSelectors } from '../../selectors';
import * as Store from '../../Store';
import { Utilities } from '../../Utilities';
import { MainLayout } from '../MainLayout/MainLayout';

const tinycolor = require('tinycolor2');

type RouteParams = RouteComponentProps<
  {
    vrid: number;
    type: 'collection' | 'delivery';
    id: number;
    concessionStoreId?: number;
  },
  {}
>;

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  RouteParams;

interface State {}

class Over18 extends React.Component<Props, State> {
  public componentDidMount() {
    this.props.LoadRestaurant(this.props);
  }

  private loginAndNavigateTo = () => {
    this.props.PushLoginUrl(window.location.hash.substr(1));

    if (this.props.params.type == 'delivery') {
      Utilities.navigateTo('/phone/' + this.props.params.id);
    } else {
      Utilities.navigateTo('/phone');
    }
  };

  public removeAlcohol = () => {
    //Indices of alcoholic items
    const itemsToBeRemoved: number[] = [];

    //Non-alcoholic items
    const itemsToKeep = [];

    const { BasketItems, Restaurant } = this.props;

    switch (Restaurant.status) {
      case 'pending':
      case 'none':
        return;
      default:
        break;
    }

    //The items to be removed are added in a backwards order as the basket in the store is an array and modifying it changes the indices
    for (let i = BasketItems.items.length - 1; i >= 0; i--) {
      if (BasketItems.items[i].Item.Alcohol) {
        itemsToBeRemoved.push(i);
      } else {
        itemsToKeep.push(BasketItems.items[i]);
      }
    }

    for (const index of itemsToBeRemoved) {
      this.props.RemoveItemFromBasket({ menuId: this.props.menuId, index });
    }

    const currentBasketTotal = BasketControl.Total(itemsToKeep);

    const { params } = this.props;

    const next =
      currentBasketTotal < Restaurant.data.MinimumOrder
        ? 'restaurant'
        : 'checkout';
    const nextUrl = `/${next}/${params.vrid}/${params.type}/${params.id}${
      params.concessionStoreId ? '/' + params.concessionStoreId : ''
    }`;

    if (this.props.Customer.status == 'success') {
      Utilities.navigateTo(nextUrl);
    } else {
      // If we are not logged in then show the login box.
      this.loginAndNavigateTo();
    }
  };

  public overEighteen = () => {
    axios.put('/Account/OverAlcoholAgeLimit/true').then(() => {
      this.props.UpdateCustomer();
    });

    const { params } = this.props;
    const nextUrl = `/checkout/${params.vrid}/${params.type}/${params.id}`;
    if (this.props.Customer.status == 'success') {
      Utilities.navigateTo(nextUrl);
    } else {
      // If we are not logged in then show the login box.
      this.loginAndNavigateTo();
    }
  };

  public render() {
    const { type, vrid, id, concessionStoreId } = this.props.params;
    const back =
      '/restaurant/' +
      vrid +
      '/' +
      type +
      '/' +
      id +
      (concessionStoreId ? '/' + concessionStoreId : '');

    const { Customer, translate, AppDesignScheme, isDark } = this.props;

    switch (Customer.status) {
      case 'pending':
      case 'none':
        return null;
      default:
        break;
    }

    const {
      ConfirmButtonText,
      DenyButtonText,
      MessageText,
    } = Customer.data.RequireAgeConfirmationForAlcoholOrdersData;

    const styles = {
      primary: {
        color: AppDesignScheme.Primary,
      },
      secondary: {
        color: AppDesignScheme.Secondary,
      },
      tertiary: {
        color: AppDesignScheme.Tertiary,
      },
      nav: {
        ':hover': {},
        ':active': {},
      },
      secondaryActive: {
        color: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString(),
      },
      secondaryHover: {
        color: tinycolor(AppDesignScheme.Secondary)
          .darken(5)
          .toString(),
      },
      subheader: {
        borderColor: AppDesignScheme.Secondary,
        boxShadow: `1px 1px 9px -5px ${AppDesignScheme.Secondary}`,
        backgroundColor: tinycolor(AppDesignScheme.Primary)
          .darken(3)
          .toString(),
      },
      darkSubheader: {
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .darken(10)
          .toString(),
        backgroundColor: tinycolor(AppDesignScheme.Tertiary)
          .lighten(10)
          .toString(),
        boxShadow: `1px 1px 9px -5px ${tinycolor(
          AppDesignScheme.Tertiary,
        ).darken(10)}`,
      },
      buttonSecondary: {
        backgroundColor: AppDesignScheme.Secondary,
        ':hover': {},
        ':active': {},
        ':focus': {},
      },
      buttonActive: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString(),
      },
      buttonHover: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(5)
          .toString(),
      },
    };

    return (
      <MainLayout>
        <div className="container">
          <div className="row over-18">
            <div className="col-md-12">
              <h1
                id="skip-to-content"
                className="secondary sm-center"
                style={isDark ? styles.primary : styles.secondary}
              >
                {translate('Checkout')}
              </h1>
              <Link to={back}>
                <div
                  key="fd-nav"
                  className="fd-nav flex flex-align-center"
                  style={styles.nav as any}
                >
                  <i
                    className="arrow_carrot-left tertiary"
                    style={
                      Radium.getState(this.state, 'fd-nav', ':active')
                        ? styles.secondaryActive
                        : Radium.getState(this.state, 'fd-nav', ':hover')
                        ? styles.secondaryHover
                        : isDark
                        ? styles.primary
                        : styles.tertiary
                    }
                  />
                  <p
                    className="inline-block clear-margins tertiary bold"
                    style={
                      Radium.getState(this.state, 'fd-nav', ':active')
                        ? styles.secondaryActive
                        : Radium.getState(this.state, 'fd-nav', ':hover')
                        ? styles.secondaryHover
                        : isDark
                        ? styles.primary
                        : styles.tertiary
                    }
                  >
                    <u>{translate('Back')}</u>
                  </p>
                </div>
              </Link>
              <div
                className="fd-subheader flex flex-align-center"
                style={isDark ? styles.darkSubheader : styles.subheader}
              >
                <i
                  className="icon_error-triangle secondary"
                  aria-hidden="true"
                  style={isDark ? styles.primary : styles.secondary}
                />
                <h2
                  className="inline-block secondary clear-margins"
                  style={isDark ? styles.primary : styles.secondary}
                >
                  {translate('Over_18')}
                </h2>
              </div>
              <p
                className="tertiary fd-info"
                style={isDark ? styles.primary : styles.tertiary}
              >
                {MessageText}
              </p>
              <div className="text-center over-18__buttons xs-flex flex-column flex-justify-stretch">
                <button
                  className="fd-button fd-button--big fd-button--secondary"
                  onClick={this.removeAlcohol}
                  key="accept-button-bottom"
                  style={
                    [
                      styles.buttonSecondary,
                      Radium.getState(
                        this.state,
                        'accept-button-bottom',
                        ':active',
                      )
                        ? styles.buttonActive
                        : Radium.getState(
                            this.state,
                            'accept-button-bottom',
                            ':hover',
                          )
                        ? styles.buttonHover
                        : null,
                    ] as any
                  }
                >
                  <p className="clear-margins primary" style={styles.primary}>
                    {DenyButtonText}
                  </p>
                </button>
                <button
                  className="fd-button fd-button--big fd-button--secondary"
                  onClick={this.overEighteen}
                  key="deny-button-bottom"
                  style={
                    [
                      styles.buttonSecondary,
                      Radium.getState(
                        this.state,
                        'deny-button-bottom',
                        ':active',
                      )
                        ? styles.buttonActive
                        : Radium.getState(
                            this.state,
                            'deny-button-bottom',
                            ':hover',
                          )
                        ? styles.buttonHover
                        : null,
                    ] as any
                  }
                >
                  <p className="clear-margins primary" style={styles.primary}>
                    {ConfirmButtonText}
                  </p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </MainLayout>
    );
  }
}

const mapStateToProps = (state: Store.State, ownProps: Routes.Routes) => {
  const { flipdish, deliveryOptions } = state;
  const { MenuData, CollectionSummaries } = flipdish;
  const menu =
    ownProps.params.type == 'delivery'
      ? menuSelectors.findDeliveryMenu(
          {
            deliveryOptions,
            MenuData,
          },
          {
            vrId: ownProps.params.vrid,
            deliveryLocationId: ownProps.params.id,
          },
        )
      : menuSelectors.findCollectionMenu(
          {
            CollectionSummaries,
            MenuData,
          },
          {
            vrId: ownProps.params.vrid,
            prId: ownProps.params.id,
          },
        );

  const menuId = (menu && menu.MenuId) || 0;
  const basket = basketSelectors.getBasketBridge(state);

  return {
    Restaurant: Routes.FindRestaurant(state, ownProps),
    BasketItems: basket,
    Customer: flipdish.Customer,
    translate: getTranslate(state.locale),
    AppDesignScheme: state.appDesignScheme,
    isDark: flipdish.isDark,
    menuId,
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<Store.State, {}, Action>,
) => {
  return {
    LoadRestaurant: (routes: Routes.Routes) => {
      dispatch(Actions.LoadRestaurant(routes));
    },
    RemoveItemFromBasket: (payload: {
      menuId: number;
      index: number;
      indexName?: string;
    }) => {
      dispatch(Actions.RemoveFromBasket(payload));
    },
    PushLoginUrl: (url: string) => {
      dispatch(Actions.PushAfterLogin(url));
    },
    UpdateCustomer: () => {
      dispatch(Actions.UpdateCustomer());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Radium(Over18));
